<script lang="ts" setup>
const props = defineProps({
  score: {
    default: 0,
    type: Number,
  },
})

const { t } = useI18n()

const scoringColor = computed(() => {
  if (!props.score) {
    return 'gray'
  }

  if (props.score >= 80) {
    return 'red'
  }

  if (props.score >= 50) {
    return 'yellow'
  }

  return 'blue'
})

const scoringLabel = computed(() => {
  if (!props.score) {
    return t('undefined')
  }

  if (props.score >= 80) {
    return t('high')
  }

  if (props.score >= 50) {
    return t('medium')
  }

  return t('low')
})
</script>

<template>
  <div class="flex select-none items-center gap-2 text-sm">
    <BaseCircle
      class="size-4.5"
      :color="scoringColor"
    />

    {{ scoringLabel }}

    <span v-if="typeof score === 'number'">
      ({{ score }})
    </span>
  </div>
</template>

<i18n lang="json">
{
  "en": {
    "high": "High",
    "low": "Low",
    "medium": "Medium",
    "undefined": "Undefined"
  },
  "es": {
    "high": "Alto",
    "low": "Bajo",
    "medium": "Medio",
    "undefined": "Indefinido"
  },
  "fr": {
    "high": "Élevé",
    "low": "Faible",
    "medium": "Moyen",
    "undefined": "Indéfini"
  }
}
</i18n>
